import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import {
  resetChannelEmails,
  requestActiveChannelCredits,
  retrieveCampaignsChannels,
  requestActiveEmailChannelStatistics,
  setActiveChannelDisplay,
  requestActiveEmailChannelReputation,
  setActiveEmailChannelStatisticsDate,
  resetActiveChannelDisplay,
  resetActiveEmailChannelStatistics,
  resetActiveChannelCredits,
  resetActiveEmailChannelReputation,
  resetCampaignsChannels,
  resetDeleteEmailChannelDomain,
  changeCampaignsModal,
  resetSendBulkEmails,
  retrieveChannelEmails,
  resetActiveChannelSource,
  resetAddEmailChannel,
  resetAddSmsChannel,
  resetDeleteEmailChannel,
  requestActiveChannelSource,
  resetPurchaseNumber,
  resetDeleteSmsChannelNumber,
  resetSendBulkSms,
  retrieveChannelSms,
} from "../../../redux/actions/campaigns";
import DashboardCampaignsDeleteDomainModal from "./modals/delete-domain-modal";
import DashboardCampaignsDistributeModal from "./modals/distribute-modal";
import DashboardCampaignsVerifyDomainModal from "./modals/verify-domain-modal";
import DashboardCampaignsCompleteSetupModal from "./modals/complete-setup-modal";
import DashboardCampaignsViewEmailModal from "./modals/view-email-modal";
import DashboardCampaignsChangeEmailReachModal from "./modals/change-email-reach-modal";
import DashboardCampaignsChangeSmsReachModal from "./modals/change-sms-reach-modal";
import DashboardCampaignsAddChannelModal from "./modals/add-channel-modal";
import DashboardCampaignsDeleteChannelModal from "./modals/delete-channel-modal";
import DashboardCampaignsPurchaseNumberModal from "./modals/purchase-number-modal";
import DashboardCampaignsDeleteNumberModal from "./modals/delete-number-modal";
import {
  setActivePage,
  setActiveChildPage,
} from "../../../redux/actions/active-page";
import {
  sendErrorNotification,
  sendSuccessNotification,
} from "../../universal/notifications/notifications";
import ChannelHistory from "./channel-history";
import ChannelDetails from "./channel-details";
import { database } from "../../../networking/firebase";
import { useHistory } from "react-router-dom";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );
  const channels = useSelector((state) => state.campaigns.channels);
  const modal = useSelector((state) => state.campaigns.showModals);
  const activeChannel = useSelector((state) => state.campaigns.activeChannel);
  const channelsLoading = useSelector(
    (state) => state.campaigns.fetchAllChannels.loading
  );
  const channelsError = useSelector(
    (state) => state.campaigns.fetchAllChannels.error
  );

  const deleteChannelDomainStatus = useSelector(
    (state) => state.campaigns.deleteEmailChannelDomain.status
  );
  const deleteChannelDomainError = useSelector(
    (state) => state.campaigns.deleteEmailChannelDomain.error
  );

  const verificationStatus = useSelector(
    (state) => state.campaigns.initializeDomain.verification.status
  );
  const verificationError = useSelector(
    (state) => state.campaigns.initializeDomain.verification.error
  );

  const addEmailChannelStatus = useSelector(
    (state) => state.campaigns.addEmailChannel.status
  );
  const addEmailChannelError = useSelector(
    (state) => state.campaigns.addEmailChannel.error
  );
  const addEmailChannelDetails = useSelector(
    (state) => state.campaigns.addEmailChannel.details
  );

  const addSmsChannelStatus = useSelector(
    (state) => state.campaigns.addSmsChannel.status
  );
  const addSmsChannelError = useSelector(
    (state) => state.campaigns.addSmsChannel.error
  );
  const addSmsChannelDetails = useSelector(
    (state) => state.campaigns.addSmsChannel.details
  );

  const deleteEmailChannelStatus = useSelector(
    (state) => state.campaigns.deleteEmailChannel.status
  );
  const deleteEmailChannelError = useSelector(
    (state) => state.campaigns.deleteEmailChannel.error
  );

  const sendBulkEmailStatus = useSelector(
    (state) => state.campaigns.sendBulkEmails.status
  );
  const sendBulkEmailError = useSelector(
    (state) => state.campaigns.sendBulkEmails.error
  );

  const sendBulkSmsStatus = useSelector(
    (state) => state.campaigns.sendBulkSms.status
  );
  const sendBulkSmsError = useSelector(
    (state) => state.campaigns.sendBulkSms.error
  );

  const changeEmailReachStatus = useSelector(
    (state) => state.campaigns.changeEmailPlan.status
  );
  const changeEmailReachError = useSelector(
    (state) => state.campaigns.changeEmailPlan.error
  );

  const purchaseNumberStatus = useSelector(
    (state) => state.campaigns.purchaseNumber.status
  );
  const purchaseNumberError = useSelector(
    (state) => state.campaigns.purchaseNumber.error
  );

  const deleteNumberStatus = useSelector(
    (state) => state.campaigns.deleteSmsChannelNumber.status
  );
  const deleteNumberError = useSelector(
    (state) => state.campaigns.deleteSmsChannelNumber.error
  );

  const statisticsFilterDate = useSelector(
    (state) => state.campaigns.activeChannel.statistics.date
  );

  const changeSmsReachStatus = useSelector(
    (state) => state.campaigns.changeSmsPlan.status
  );
  const changeSmsReachError = useSelector(
    (state) => state.campaigns.changeSmsPlan.error
  );

  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    dispatch(setActivePage("campaigns"));
    dispatch(setActiveChildPage("campaigns"));
  });

  // START

  useEffect(() => {
    if (selectedCompany) {
      dispatch(retrieveCampaignsChannels({ companyId: selectedCompany }));
    }
  }, [selectedCompany]);

  // START 2

  useEffect(() => {
    if (
      firstLoad &&
      channels &&
      channels.length > 0 &&
      !activeChannel.username
    ) {
      const firstChannel = channels && channels[0];
      if (Object.keys(firstChannel).length > 0) {
        dispatch(
          setActiveChannelDisplay({
            username: firstChannel.username,
            email: firstChannel.email,
            type: firstChannel.type,
            timestamp: firstChannel.timestamp,
            id: firstChannel.id,
            active: firstChannel.active,
          })
        );
        dispatch(
          requestActiveChannelCredits({
            companyId: selectedCompany,
            channelId: firstChannel.id,
            type: firstChannel.type,
          })
        );
        dispatch(
          requestActiveChannelSource({
            companyId: selectedCompany,
            channelId: firstChannel.id,
            username: firstChannel.username,
            type: firstChannel.type,
          })
        );
        if (firstChannel.type === "email") {
          const filterDate = moment(Date.now())
            .startOf("month")
            .format("YYYY-MM-DD");
          dispatch(setActiveEmailChannelStatisticsDate(filterDate));
          dispatch(
            requestActiveEmailChannelReputation({
              companyId: selectedCompany,
              channelId: firstChannel.id,
            })
          );
          dispatch(
            requestActiveEmailChannelStatistics({
              companyId: selectedCompany,
              channelId: firstChannel.id,
              date: filterDate,
            })
          );
        }
        setFirstLoad(false);
      } else {
        //UNIVERSAL
        dispatch(resetActiveChannelCredits());
        //EMAIL CHANNEL
        dispatch(resetActiveEmailChannelStatistics());
        dispatch(resetActiveEmailChannelReputation());
        dispatch(resetActiveChannelSource());
        dispatch(resetChannelEmails());
      }
    }
  }, [channels]);

  // VED FEIL AV LASTING AV KANALER
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (!channelsLoading && channelsError) {
      dispatch(resetActiveChannelDisplay());
      dispatch(resetActiveEmailChannelStatistics());
      dispatch(resetActiveChannelCredits());
      dispatch(resetActiveEmailChannelReputation());
      dispatch(resetChannelEmails());
      dispatch(resetActiveChannelSource());
      //reset active channel sms også
    }
  }, [channelsLoading, channelsError]);

  //FULLSTENDIG VERIFISERING (DOMENE)
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (verificationStatus) {
      sendSuccessNotification("Domenet ble verifisert.");
      dispatch(changeCampaignsModal({ completeSetupModal: false }));
      if (activeChannel.username) {
        dispatch(
          requestActiveChannelCredits({
            companyId: selectedCompany,
            channelId: activeChannel.id,
            type: activeChannel.type,
          })
        );
        dispatch(
          requestActiveEmailChannelReputation({
            companyId: selectedCompany,
            channelId: activeChannel.id,
          })
        );
        dispatch(
          requestActiveEmailChannelStatistics({
            companyId: selectedCompany,
            channelId: activeChannel.id,
            date: statisticsFilterDate,
          })
        );
        dispatch(
          requestActiveChannelSource({
            companyId: selectedCompany,
            channelId: activeChannel.id,
            username: activeChannel.username,
            type: activeChannel.type,
          })
        );
      }
    }
  }, [verificationStatus]);

  // VERIFISERING FEILET
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (verificationError) {
      sendErrorNotification("Kunne ikke verifisere domene.");
    }
  }, [verificationError]);

  // NY KANAL OPPRETTET (E-POST)
  // STATUS: TESTET

  useEffect(() => {
    if (addEmailChannelStatus && addEmailChannelStatus === "success") {
      dispatch(changeCampaignsModal({ newChannelModal: false }));
      dispatch(retrieveCampaignsChannels({ companyId: selectedCompany }));
      if (addEmailChannelDetails.username) {
        dispatch(
          setActiveChannelDisplay({
            username: addEmailChannelDetails.username,
            email: addEmailChannelDetails.email,
            type: addEmailChannelDetails.type,
            timestamp: addEmailChannelDetails.timestamp,
            id: addEmailChannelDetails.id,
          })
        );
        dispatch(
          requestActiveChannelCredits({
            companyId: selectedCompany,
            channelId: activeChannel.id,
            type: activeChannel.type,
          })
        );
        dispatch(
          requestActiveEmailChannelReputation({
            companyId: selectedCompany,
            channelId: addEmailChannelDetails.id,
          })
        );
        dispatch(
          requestActiveEmailChannelStatistics({
            companyId: selectedCompany,
            channelId: addEmailChannelDetails.id,
            date: statisticsFilterDate,
          })
        );
        dispatch(
          requestActiveChannelSource({
            companyId: selectedCompany,
            channelId: activeChannel.id,
            username: activeChannel.username,
            type: activeChannel.type,
          })
        );
      }
      sendSuccessNotification("Kanalen ble opprettet.");
      dispatch(resetAddEmailChannel());
    }
  }, [addEmailChannelStatus, addEmailChannelDetails]);

  // KUNNE IKKE OPPRETTE KANAL (E-POST)
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (addEmailChannelError) {
      sendErrorNotification("Kunne ikke legge til ny kanal.");
      dispatch(resetAddEmailChannel());
    }
  }, [addEmailChannelError]);

  // UTSENDELSE AV E-POST
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (sendBulkEmailStatus && sendBulkEmailStatus === "success") {
      sendSuccessNotification("E-postene ble sendt.");
      dispatch(resetSendBulkEmails());
      dispatch(
        retrieveChannelEmails({
          companyId: selectedCompany,
          channelId: activeChannel.id,
        })
      );
      dispatch(
        requestActiveEmailChannelStatistics({
          companyId: selectedCompany,
          channelId: activeChannel.id,
          date: statisticsFilterDate,
        })
      );
      dispatch(
        requestActiveChannelCredits({
          companyId: selectedCompany,
          channelId: activeChannel.id,
        })
      );
    }
  }, [sendBulkEmailStatus]);

  useEffect(() => {
    if (sendBulkSmsStatus && sendBulkSmsStatus === "success") {
      sendSuccessNotification("SMS ble sendt.");
      dispatch(resetSendBulkSms());
      dispatch(
        retrieveChannelSms({
          companyId: selectedCompany,
          channelId: activeChannel.id,
        })
      );
      dispatch(
        requestActiveChannelCredits({
          companyId: selectedCompany,
          channelId: activeChannel.id,
          type: activeChannel.type,
        })
      );
      dispatch(
        requestActiveChannelSource({
          companyId: selectedCompany,
          channelId: activeChannel.id,
          username: activeChannel.username,
          type: activeChannel.type,
        })
      );
    }
  }, [sendBulkSmsStatus]);

  useEffect(() => {
    if (sendBulkSmsError) {
      sendErrorNotification("Kunne ikke sende SMS.");
      dispatch(resetSendBulkSms());
    }
  }, [sendBulkSmsError]);

  // FEILET UTSENDELSE AV E-POST
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (sendBulkEmailError) {
      sendErrorNotification("Kunne ikke sende e-poster.");
      dispatch(resetSendBulkEmails());
    }
  }, [sendBulkEmailError]);

  // ENDRE REACH PÅ MAIL
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (changeEmailReachStatus) {
      dispatch(changeCampaignsModal({ changeEmailReachModal: false }));
      sendSuccessNotification("Rekkevidden ble oppdatert.");
      dispatch(
        requestActiveChannelCredits({
          companyId: selectedCompany,
          channelId: activeChannel.id,
          type: activeChannel.type,
        })
      );
    }
  }, [changeEmailReachStatus]);

  // KUNNE IKKE ENDRE REKKEVIDDE PÅ E-POST
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (changeEmailReachError) {
      dispatch(changeCampaignsModal({ changeEmailReachModal: false }));
      sendErrorNotification("Kunne ikke oppgradere rekkevidde.");
    }
  }, [changeEmailReachError]);

  // NY KANAL OPPRETTET (SMS)
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (addSmsChannelStatus && addSmsChannelStatus === "success") {
      dispatch(changeCampaignsModal({ newChannelModal: false }));
      dispatch(retrieveCampaignsChannels({ companyId: selectedCompany }));
      if (addSmsChannelDetails.username) {
        dispatch(
          setActiveChannelDisplay({
            username: addSmsChannelDetails.username,
            type: addSmsChannelDetails.type,
            timestamp: addSmsChannelDetails.timestamp,
            id: addSmsChannelDetails.id,
            active: addSmsChannelDetails.active,
          })
        );
        dispatch(
          requestActiveChannelCredits({
            companyId: selectedCompany,
            channelId: addSmsChannelDetails.id,
            type: addSmsChannelDetails.type,
          })
        );
        dispatch(
          requestActiveChannelSource({
            companyId: selectedCompany,
            channelId: addSmsChannelDetails.id,
            username: addSmsChannelDetails.username,
            type: addSmsChannelDetails.type,
          })
        );
      }
      sendSuccessNotification("Kanalen ble opprettet.");
      dispatch(resetAddEmailChannel());
    }
  }, [addSmsChannelStatus, addSmsChannelDetails]);

  // KUNNE IKKE OPPRETTE KANAL (SMS)
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (addSmsChannelError) {
      sendErrorNotification("Kunne ikke legge til ny kanal.");
      dispatch(resetAddSmsChannel());
    }
  }, [addSmsChannelError]);

  // SLETTE E-POST DOMENE
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (deleteChannelDomainStatus && deleteChannelDomainStatus === "success") {
      sendSuccessNotification("Domenet ble slettet.");
      dispatch(resetDeleteEmailChannelDomain());
      if (activeChannel.username) {
        dispatch(
          requestActiveChannelCredits({
            companyId: selectedCompany,
            channelId: activeChannel.id,
            type: activeChannel.type,
          })
        );
        dispatch(
          requestActiveEmailChannelReputation({
            companyId: selectedCompany,
            channelId: activeChannel.id,
          })
        );
        dispatch(
          requestActiveEmailChannelStatistics({
            companyId: selectedCompany,
            channelId: activeChannel.id,
            date: statisticsFilterDate,
          })
        );
        dispatch(
          requestActiveChannelSource({
            companyId: selectedCompany,
            channelId: activeChannel.id,
            username: activeChannel.username,
            type: activeChannel.type,
          })
        );
      }
    }
  }, [deleteChannelDomainStatus]);

  // KUNNE IKKE SLETTE E-POST DOMENE
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (deleteChannelDomainError) {
      sendErrorNotification("Kunne ikke slette domenet.");
      dispatch(resetDeleteEmailChannelDomain());
    }
  }, [deleteChannelDomainError]);

  // SLETTE KANAL (E-POST)
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (deleteEmailChannelStatus) {
      sendSuccessNotification("Kanalen ble slettet.");
      dispatch(resetDeleteEmailChannel());
      setFirstLoad(true);
      dispatch(resetActiveChannelDisplay());
      dispatch(resetCampaignsChannels());
      dispatch(retrieveCampaignsChannels({ companyId: selectedCompany }));
    }
  }, [deleteEmailChannelStatus]);

  // KUNNE IKKE SLETTE KANAL (E-POST)
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (deleteEmailChannelError) {
      sendErrorNotification("Kunne ikke slette kanal.");
      dispatch(resetDeleteEmailChannel());
    }
  }, [deleteEmailChannelError]);

  // IGNORE.....

  useEffect(() => {
    dispatch(resetActiveChannelDisplay());
    dispatch(resetActiveEmailChannelStatistics());
    dispatch(resetActiveChannelCredits());
    dispatch(resetActiveEmailChannelReputation());
    dispatch(resetAddEmailChannel());
    dispatch(resetAddSmsChannel());
    dispatch(resetDeleteEmailChannel());
  }, []);

  // KJØPE NUMMER
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (purchaseNumberStatus === "success") {
      sendSuccessNotification("Nummeret ble kjøpt.");
      dispatch(resetPurchaseNumber());
      dispatch(changeCampaignsModal({ purchaseNumberModal: false }));
      if (activeChannel.username) {
        dispatch(
          setActiveChannelDisplay({
            username: activeChannel.username,
            type: activeChannel.type,
            timestamp: activeChannel.timestamp,
            id: activeChannel.id,
            active: activeChannel.active,
          })
        );
        dispatch(
          requestActiveChannelCredits({
            companyId: selectedCompany,
            channelId: activeChannel.id,
            type: activeChannel.type,
          })
        );
        dispatch(
          requestActiveChannelSource({
            companyId: selectedCompany,
            channelId: activeChannel.id,
            username: activeChannel.username,
            type: activeChannel.type,
          })
        );
      }
    }
  }, [purchaseNumberStatus]);

  useEffect(() => {
    if (purchaseNumberError) {
      sendErrorNotification("Kunne ikke kjøpe nummer.");
      dispatch(resetPurchaseNumber());
    }
  }, [purchaseNumberError]);

  useEffect(() => {
    if (deleteNumberError) {
      sendErrorNotification("Kunne ikke slette nummer.");
      dispatch(resetDeleteSmsChannelNumber());
    }
  }, [deleteNumberError]);

  useEffect(() => {
    if (deleteNumberStatus && deleteNumberStatus === "success") {
      sendSuccessNotification("Nummeret ble slettet.");
      dispatch(resetDeleteSmsChannelNumber());
      dispatch(
        setActiveChannelDisplay({
          username: activeChannel.username,
          email: activeChannel.email,
          type: activeChannel.type,
          timestamp: activeChannel.timestamp,
          id: activeChannel.id,
          active: activeChannel.active,
        })
      );
      dispatch(
        requestActiveChannelCredits({
          companyId: selectedCompany,
          channelId: activeChannel.id,
          type: activeChannel.type,
        })
      );
      dispatch(
        requestActiveChannelSource({
          companyId: selectedCompany,
          channelId: activeChannel.id,
          username: activeChannel.username,
          type: activeChannel.type,
        })
      );
    }
  }, [deleteNumberStatus]);

  /** */

  useEffect(() => {
    if (changeSmsReachStatus) {
      dispatch(changeCampaignsModal({ changeSmsReachModal: false }));
      sendSuccessNotification("Rekkevidden ble oppdatert.");
      dispatch(
        requestActiveChannelCredits({
          companyId: selectedCompany,
          channelId: activeChannel.id,
          type: activeChannel.type,
        })
      );
    }
  }, [changeSmsReachStatus]);

  // KUNNE IKKE ENDRE REKKEVIDDE PÅ E-POST
  // STATUS: IKKE TESTET

  useEffect(() => {
    if (changeSmsReachError) {
      dispatch(changeCampaignsModal({ changeSmsReachModal: false }));
      sendErrorNotification("Kunne ikke oppgradere rekkevidde.");
    }
  }, [changeSmsReachError]);

  return (
    <section className="dashboard-campaigns-section">
      <div className="inner-dashboard-campaigns-container">
        <ChannelDetails />
        <ChannelHistory />
        {modal.deleteDomainModal ? (
          <DashboardCampaignsDeleteDomainModal />
        ) : null}
        {modal.distributeModal ? <DashboardCampaignsDistributeModal /> : null}
        {modal.verifyDomainModal ? (
          <DashboardCampaignsVerifyDomainModal />
        ) : null}
        {modal.completeSetupModal ? (
          <DashboardCampaignsCompleteSetupModal />
        ) : null}
        {modal.viewEmailModal ? <DashboardCampaignsViewEmailModal /> : null}
        {modal.changeEmailReachModal ? (
          <DashboardCampaignsChangeEmailReachModal />
        ) : null}
        {modal.changeSmsReachModal ? (
          <DashboardCampaignsChangeSmsReachModal />
        ) : null}
        {modal.newChannelModal ? <DashboardCampaignsAddChannelModal /> : null}
        {modal.deleteChannelModal ? (
          <DashboardCampaignsDeleteChannelModal />
        ) : null}
        {modal.purchaseNumberModal ? (
          <DashboardCampaignsPurchaseNumberModal />
        ) : null}
        {modal.deleteNumberModal ? (
          <DashboardCampaignsDeleteNumberModal />
        ) : null}
      </div>
      <ToastContainer />
    </section>
  );
};

export default Index;
